/* ============================================
   CHIKAMICHI PROTEIN - Scroll Animations
   ============================================ */

(function() {
  'use strict';

  // Intersection Observer for fade-in animations
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -60px 0px',
    threshold: 0.1
  };

  const animationObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Once animated, stop observing
        animationObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe all animation targets
  function initAnimations() {
    var targets = document.querySelectorAll(
      '.ck-fade-in, .ck-fade-in-left, .ck-fade-in-right, .ck-stagger'
    );
    targets.forEach(function(target) {
      animationObserver.observe(target);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }

  // Re-initialize on Shopify section render (theme editor)
  document.addEventListener('shopify:section:load', initAnimations);
})();
